import discount1 from '../../assets/images/discounts/discount1.svg';
import discount2 from '../../assets/images/discounts/discount2.svg';
import discount3 from '../../assets/images/discounts/discount3.svg';
import discount4 from '../../assets/images/discounts/discount4.svg';

export type DiscountItem = {
    img: string;
    title: string;
    text: string;
};

export const discounts: DiscountItem[] = [
    {
        img: discount2,
        title: 'Трансфер',
        text: 'Скидка 10% при заказе трансфера туда - обратно, при единовременной оплате.',
    },
    {
        img: discount1,
        title: 'Летний отдых',
        text: 'При перевозке вашего близкого на дачу, в пансионат или дом отдыха, при единовременном заказе туда-обратно — предоставляется скидка в 20% на поездку обратно.',
    },
    {
        img: discount4,
        title: 'Возраст',
        text: 'Скидка 10% если возраст пассажира старше 75 лет.',
    },
    {
        img: discount3,
        title: '6-я поездка бесплатно',
        text: 'Действует при единовременном заказе поездок по договору (Диализ, Курсовые процедуры).',
    },    
];


